import { render, staticRenderFns } from "./judo.vue?vue&type=template&id=1d65d92b"
import script from "./judo.vue?vue&type=script&lang=js"
export * from "./judo.vue?vue&type=script&lang=js"
import style0 from "./judo.vue?vue&type=style&index=0&id=1d65d92b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports